
export const invoicestableheading = [
 
    "Sr.#",
    "Invoice #",
    "Status",
    "Intitator Name",
    "Issue Date",
    "Due Date",
    "Total Amount",
  ];
  
  
  
  export const invoicestabledata=[
      {
          srno:"01",
          invoiceid:'1234',
          status:'Paid',
          name:'John',
          dateissue:'19 jan,2020',
          duedate:'19 Oct,2023',
          amount:'£10245',
      },
      {
          srno:"02",
          invoiceid:'1234',
          status:'Due',
          name:'Chris',
          dateissue:'19 jan,2020',
          duedate:'19 Oct,2023',
          amount:'£10455',
      },
      {
          srno:"03",
          invoiceid:'1234',
          status:'Overdue',
          name:'Nick',
          dateissue:'19 jan,2020',
          duedate:'19 Oct,2023',
          amount:'£10245',
      },
      {
          srno:"04",
          invoiceid:'1234',
          status:'Paid',
          name:'John',
          dateissue:'19 jan,2020',
          duedate:'19 Oct,2023',
          amount:'£10245',
      },
      {
          srno:"06",
          invoiceid:'1234',
          status:'Due',
          name:'John',
          dateissue:'19 jan,2020',
          duedate:'19 Oct,2023',
          amount:'£10245',
      },
      {
          srno:"07",
          invoiceid:'1234',
          status:'Overdue',
          name:'Chris',
          dateissue:'19 jan,2020',
          duedate:'19 Oct,2023',
          amount:'£10245',
      },
      {
        srno:"08",
        invoiceid:'1234',
        status:'Overdue',
        name:'Chris',
        dateissue:'19 jan,2020',
        duedate:'19 Oct,2023',
        amount:'£10245',
    },
  ]
  
    
  